module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318936.aa32dcf2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318936.pdf
// module id = 839
// module chunks = 0